// src/components/modals/ChangePasswordModal.js
import React, { useState } from 'react';
import { X, Lock, CheckCircle, AlertTriangle } from 'lucide-react';

const ChangePasswordModal = ({ isOpen, onClose, onChangePassword }) => {
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(null);

    if (!isOpen) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage(null);

        if (newPassword !== confirmPassword) {
            setMessage({ type: 'error', text: 'A nova senha e a confirmação não coincidem.' });
            return;
        }
        if (newPassword.length < 6) {
            setMessage({ type: 'error', text: 'A nova senha deve ter no mínimo 6 caracteres.' });
            return;
        }

        setLoading(true);
        try {
            await onChangePassword(oldPassword, newPassword);
            setMessage({ type: 'success', text: 'Senha alterada com sucesso!' });
            setOldPassword(''); setNewPassword(''); setConfirmPassword('');
            setTimeout(() => { onClose(); setMessage(null); }, 2000);
        } catch (error) {
            setMessage({ type: 'error', text: error.message || 'Erro ao alterar senha.' });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
            <div className="bg-white rounded-xl shadow-md w-full max-w-md overflow-hidden animate-fade-in">
                <div className="bg-indigo-600 p-4 flex justify-between items-center text-white">
                    <h3 className="font-bold flex items-center"><Lock className="w-5 h-5 mr-2"/> Alterar Senha</h3>
                    <button onClick={onClose} className="hover:bg-indigo-700 p-1 rounded transition"><X className="w-5 h-5"/></button>
                </div>
                <div className="p-6">
                    {message && (
                        <div className={`p-3 rounded-lg mb-4 text-sm font-medium flex items-center ${message.type === 'error' ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'}`}>
                            {message.type === 'error' ? <AlertTriangle className="w-4 h-4 mr-2"/> : <CheckCircle className="w-4 h-4 mr-2"/>}
                            {message.text}
                        </div>
                    )}
                    <form onSubmit={handleSubmit} className="flex flex-col gap-4">
                        <div>
                            <label className="block text-sm font-bold text-gray-500 uppercase mb-1">Senha Antiga</label>
                            <input type="password" value={oldPassword} onChange={e => setOldPassword(e.target.value)} className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-indigo-500 outline-none" required />
                        </div>
                        <div className="border-t pt-2">
                            <label className="block text-sm font-bold text-gray-500 uppercase mb-1">Nova Senha</label>
                            <input type="password" value={newPassword} onChange={e => setNewPassword(e.target.value)} className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-indigo-500 outline-none" required />
                        </div>
                        <div>
                            <label className="block text-sm font-bold text-gray-500 uppercase mb-1">Confirmar Nova Senha</label>
                            <input type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} className={`w-full p-3 border rounded-lg outline-none ${newPassword && confirmPassword && newPassword !== confirmPassword ? 'border-red-500 ring-1 ring-red-500' : 'focus:ring-2 focus:ring-indigo-500'}`} required />
                        </div>
                        <button disabled={loading} className="mt-2 w-full bg-indigo-600 text-white py-3 rounded-lg font-bold hover:bg-indigo-700 disabled:opacity-50 transition shadow-md">
                            {loading ? 'Atualizando...' : 'Confirmar Troca'}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ChangePasswordModal;